import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Upload,
  Table,
  Typography,
  message,
  Select,
  Modal,
  Row,
  Col,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBasePath } from "../../../components/NavigatePath";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector } from "react-redux";
import utc from "dayjs/plugin/utc";

function ViewBranch() {
  dayjs.extend(utc);
  const [form] = Form.useForm();
  const location = useLocation();
  const data = location.state?.data;
  const basePath = useBasePath();
  const hasRedirected = useRef(false);
  const navigate = useNavigate();
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [dataSource, setdataSource] = useState();
  const [pharmacistsList, setPharmacistsList] = useState();
  const [pharmacistsListAdd, setPharmacistsListAdd] = useState();
  const [selectedPharmacists, setSelectedPharmacists] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  useEffect(() => {
    if (data === undefined && !hasRedirected.current) {
      message.error("Data not found.");
      hasRedirected.current = true;
      navigate(`/${basePath}/pharmacies`);
    }
  }, [data, navigate, basePath]);

  //Track edit
  const [isEditMode, setIsEditMode] = useState(false);
  const [status, setStatus] = useState(data?.active ? "Active" : "Inactive");

  const onFinish = async (value) => {
    const payload = {
      name: value.Branch_Name,
      startDate: value.startDate_branch.toISOString(),
      endDate: value.endDate_branch.toISOString(),
      PharmacyID: data.id,
      address: {
        cityID: value.city,
        district: value.district,
        street: value.street,
        floor: value.floor,
        apartment: value.apartment,
      },
    };
    console.log("payload ", payload);
    try {
      const response = await axios.post(`${API_URL}Branches`, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log(response);
      message.success(" Add branch.");
      navigate(-1);
      form.resetFields();
    } catch (error) {
      console.error("Error saving branch:", error);
      message.error(`${error.response.data.message}`);
    }
  };
  const CancelButton = () => {
    navigate(-1);
    form.resetFields();
  };

  const handleEditClick = () => {
    if (isEditMode) {
      form
        .validateFields()
        .then((values) => {
          const updatedFields = {};
          const fieldsToCheck = ["startDate", "endDate"];
          fieldsToCheck.forEach((field) => {
            const value = dayjs.utc(values[field]).startOf("day").toISOString();
            const dataValue = dayjs
              .utc(data[field])
              .startOf("day")
              .toISOString();
            if (value !== dataValue) {
              updatedFields[field] = values[field];
            }
          });

          const nameBranch = ["name"];
          nameBranch.forEach((field) => {
            if (values[field] !== data[field]) {
              updatedFields[field] = values[field];
            }
          });
          console.log("Updated", updatedFields);
          if (Object.keys(updatedFields).length > 0) {
            axios
              .patch(
                `${API_URL}Branches?id=${data.id}`,
                {
                  startDate: updatedFields.startDate,
                  endDate: updatedFields.endDate,
                  name: updatedFields.name,
                },
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                }
              )
              .then((response) => {
                console.log("Updated successfully:", response.data);
                setIsEditMode(false);
                message.success("Branch updated");
                navigate(-1);
              })
              .catch((error) => {
                console.error("Update failed:", error);
              });
          } else {
            setIsEditMode(false);
            message.info("No changes made");
          }
        })
        .catch((error) => {
          console.error("Validation failed:", error);
        });
    } else {
      setIsEditMode(true);
    }
  };

  const fetchBranch = async () => {
    try {
      const response = await axios.get(`${API_URL}Branches?id=${data.id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setPharmacistsList(response.data.Branch.pharmacists);
    } catch (error) {
      console.error("Error fetching branches:", error);
      message.error("Failed to fetch branches.");
    }
  };
  const fetchPharmacists = async () => {
    try {
      const response = await axios.get(`${API_URL}users/get-pharmacists`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const pharmacistsWithName = response.data.Pharmacists.map(
        (pharmacist) => ({
          id: pharmacist.id,
          name: `${pharmacist.userDetails.firstName} ${pharmacist.userDetails.lastName}`,
        })
      );

      setPharmacistsListAdd(pharmacistsWithName);
    } catch (error) {
      console.error("Error fetching pharmacists:", error);
      message.error("Failed to fetch pharmacists.");
    }
  };

  useEffect(() => {
    fetchBranch();
    fetchPharmacists();
  }, []);
  const columns = [
    {
      title: "Name",
      key: "name",
      render: (text, row) => (
        <span>{`${row.userDetails.firstName} ${row.userDetails.lastName}`}</span>
      ),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
    },
    {
      title: "Position",
      render: (text, row) => (
        <span>{row.userDetails.position || "No Position"}</span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, row) => (
        <div className="row-actions">
          <Button
            style={{
              borderRadius: 0,
              borderColor: "#F44336",
              backgroundColor: "#F44336",
              color: "#FFFFFF",
            }}
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];
  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setSelectedPharmacists(null);
    setModalVisible(false);
  };

  const handleSelectPharmacists = (value) => {
    setSelectedPharmacists(value);
  };

  const handleAddPharmacists = async () => {
    console.log("Selected pharmacist to add:", selectedPharmacists);
    try {
      const response = await axios.post(
        `${API_URL}Branches/addOnePharmacist`,
        {
          branchId: data.id,
          userId: selectedPharmacists,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log("response ", response);
      message.success("Pharmacist added successfully.");
      fetchBranch();
      setSelectedPharmacists(null);
      closeModal();
    } catch (e) {
      console.error("Error adding pharmacist:", e);
      message.error("Failed to add pharmacist.");
    }
  };
  const handleDelete = async (user) => {
    console.log("data ", data);
    console.log("delete ", user);
    const payload = {
      branchId: data.id,
      userId: user,
    };
    console.log("payload ", payload);

    try {
      const response = await axios.delete(
        `${API_URL}Branches/deleteOnePharmacist`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          data: payload, // Move payload inside the config object under "data"
        }
      );

      console.log("response ", response);
      console.log("Pharmacist deleted successfully.");
      message.success("Pharmacist deleted successfully.");
      fetchBranch();

      // navigate(-1);
    } catch (error) {
      console.error("Error deleting pharmacy:", error);
      message.error("Failed to delete pharmacy.");
    }
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        style={{ width: "100%" }}
        initialValues={{
          startDate: dayjs.utc(data?.startDate),
          endDate: dayjs.utc(data?.endDate),
          name: data?.name,
        }}
        onFinish={onFinish}
      >
        <div className="flex flex-row items-center font-semibold mb-4 text-lg md:text-xl lg:text-2xl">
          Profile -
          <span className="font-normal ml-2 md:ml-4">
            {data ? data.name : null}
          </span>
        </div>

        <div className="flex flex-col bg-white p-4 md:p-6 lg:p-10 rounded-sm">
          <Row gutter={[16, 16]} className="w-full">
            <Col xs={24}>
              <div className="flex flex-col space-y-4 md:space-y-5">
                <div className="flex flex-col sm:flex-row justify-between gap-3">
                  <div className="flex flex-row items-center space-x-2">
                    <p className="text-sm md:text-base">Activity status</p>
                    <div
                      className={`p-1 md:p-2 ${status === "Active"
                        ? "bg-[#E8FAE9] text-[#14CC26]"
                        : "bg-[#F8D7DA] text-[#FF0000]"
                        }`}
                    >
                      <p>{status}</p>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                    <Button
                      className="py-2 px-4 md:py-3 md:px-6 lg:py-4 lg:px-10 text-sm lg:text-base"
                      style={{
                        color: isEditMode ? "white" : "#3371EB",
                        borderColor: "#3371EB",
                        backgroundColor: isEditMode ? "#3371EB" : null,
                      }}
                      onClick={handleEditClick}
                    >
                      {isEditMode ? "Save" : "Edit"}
                    </Button>
                    <Button
                      type=""
                      onClick={CancelButton}
                      className="py-2 px-4 md:py-3 md:px-6 lg:py-4 lg:px-10 text-sm lg:text-base"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Name Branch
                        </span>
                      }
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract Start Date",
                        },
                      ]}
                    >
                      <Input
                        disabled={!isEditMode}
                        className="h-9 md:h-10"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Contract Start Date
                        </span>
                      }
                      name="startDate"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract Start Date",
                        },
                      ]}
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%" }}
                        className="h-9 md:h-10"
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Contract End Date
                        </span>
                      }
                      name="endDate"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract End Date",
                        },
                      ]}
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%" }}
                        className="h-9 md:h-10"
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mt-4">
                  <p className="text-lg md:text-xl font-semibold mb-2 sm:mb-0">
                    Pharmacists
                  </p>
                  <Button
                    onClick={openModal}
                    className="py-2 px-3 md:py-3 md:px-4 text-sm md:text-base"
                    style={{
                      backgroundColor: "#3371EB",
                      color: "white",
                    }}
                  >
                    + Pharmacist
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          <div className="w-full mt-6 md:mt-8 lg:mt-12 overflow-x-auto">
            <Table
              className="customTable"
              style={{ backgroundColor: "#FFFFFF" }}
              columns={columns}
              dataSource={pharmacistsList}
              rowKey="key"
              scroll={{ x: 'max-content' }}
              pagination={{ responsive: true }}
              locale={{
                emptyText: (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "300px",
                      width: "100%",
                    }}
                  >
                    <Typography.Text
                      className="text-xl md:text-2xl lg:text-3xl"
                      style={{
                        color: "#C0D3F9",
                        fontWeight: 400,
                      }}
                    >
                      No Pharmacists Here
                    </Typography.Text>
                  </div>
                ),
              }}
            />
          </div>
        </div>
      </Form>

      <Modal
        title="Select Pharmacist"
        visible={modalVisible}
        onOk={handleAddPharmacists}
        onCancel={closeModal}
        okText="Add"
        cancelText="Cancel"
      >
        <Select
          style={{ width: "100%" }}
          placeholder="Select a pharmacist"
          onChange={handleSelectPharmacists}
          optionLabelProp="label"
          value={selectedPharmacists}
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        >
          {pharmacistsListAdd?.map((pharmacist) => (
            <Select.Option
              key={pharmacist.id}
              value={pharmacist.id}
              label={`${pharmacist.name}`}
            >
              {`${pharmacist.name}`}
            </Select.Option>
          ))}
        </Select>
      </Modal>
    </>
  );
}

export default ViewBranch;
